export const commercialMetadata = {
  contact: {
    path: "/contact",
    title: "Contact Quantingo | Discuss a Project or Partnership",
    description:
      "Start a project or referral partner conversation with Quantingo. One free qualification call, up to 30 minutes, followed by a paid Assessment from US$100.",
  },
  "how-we-work": {
    path: "/how-we-work",
    title: "How We Work | Engineering Engagements | Quantingo",
    description:
      "From a free qualification call to a paid Engineering Assessment starting at US$100, a clear proposal and defined engineering packages. See how Quantingo works.",
  },
  services: {
    path: "/services",
    title: "Engineering Services | Software & Systems | Quantingo",
    description:
      "Senior engineering for embedded and IoT devices, AI, backend platforms, Android products and IT infrastructure. Architecture through production delivery.",
  },
  engineering: {
    path: "/engineering",
    title: "Engineering Approach | Architecture & Reliability | Quantingo",
    description:
      "How Quantingo approaches architecture, reliability, integration and production constraints, with senior technical ownership across the complete system.",
  },
  partners: {
    path: "/partners",
    title: "Referral Partner Program | Quantingo",
    description:
      "Refer engineering projects to Quantingo. Rates of 5%, 10% or 15% apply to eligible revenue attributable to the first six months of implementation.",
  },
};
